import type { PlainDateString } from "@sa-nu/shared-utils/date";
import { PlainDate, genPlainDateList } from "@sa-nu/shared-utils/date";
import { parsePlainDate } from "@sa-nu/shared-utils/date";

/**
 * 空き状況セルのステータス判定ユーティリティ
 */

/**
 * ある日のある宿泊施設が予約されているかどうか
 */
export function isDateIncludedInReservation(
  reservation:
    | {
        firstNight: PlainDateString;
        lastNight: PlainDateString;
        accommodation: {
          id: string;
        };
      }
    | {
        firstNight: PlainDate;
        lastNight: PlainDate;
        accommodationId: string;
      }
    | undefined
    | null,
  target: {
    accommodationId: string;
    date: PlainDate;
  },
): boolean {
  if (!reservation) return false;
  const reservedDates = genPlainDateList(
    reservation.firstNight,
    reservation.lastNight,
  );
  const accommodationId =
    "accommodationId" in reservation
      ? reservation.accommodationId
      : reservation.accommodation.id;
  return (
    accommodationId === target.accommodationId &&
    reservedDates.some((date) => PlainDate.compare(date, target.date) === 0)
  );
}

/**
 * 空き状況データの最小インターフェース
 */
type AvailabilityData = {
  date: PlainDateString;
  isAvailable: boolean;
};

/**
 * チェックアウト日としての基本条件
 * - 現在の lastNight の翌日からその日まで間が全て空いていること
 */
export function canSelectAsCheckoutDate(
  date: PlainDate,
  originalReservationData: {
    lastNight: PlainDateString;
  },
  availabilities: readonly AvailabilityData[],
): boolean {
  const night = date.subtract({ days: 1 });
  const lastNight = parsePlainDate(originalReservationData.lastNight).add({
    days: 1,
  });

  const nightListFromLastNight = genPlainDateList(lastNight, night);

  return nightListFromLastNight.every(
    (d) =>
      availabilities.find(
        (a) => PlainDate.compare(parsePlainDate(a.date), d) === 0,
      )?.isAvailable,
  );
}
